import React, { useState } from "react";
import { makeStyles, Paper, Typography, Button, CircularProgress } from "@material-ui/core";
import { CloudDownload as CloudDownloadIcon, Storage as StorageIcon } from "@material-ui/icons";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  description: {
    marginBottom: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  buttonContainer: {
    display: "flex",
    alignItems: "center",
  },
  wrapper: {
    position: "relative",
    display: "inline-block",
  },
  buttonProgress: {
    color: theme.palette.primary.main,
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const DatabaseBackup = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const handleDownloadBackup = async () => {
    setLoading(true);
    try {
      const response = await api.get("/database-backup/download", {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      const contentDisposition = response.headers["content-disposition"];
      let fileName = `backup-postgres-${new Date().toISOString().slice(0, 10)}.sql`;

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          fileName = match[1];
        }
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success("Backup do banco de dados baixado com sucesso!");
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper className={classes.paper} elevation={0}>
      <div className={classes.header}>
        <StorageIcon color="primary" fontSize="large" />
        <Typography variant="h6" component="h2">
          Backup do Banco de Dados PostgreSQL
        </Typography>
      </div>

      <Typography variant="body1" className={classes.description}>
        Clique no botão abaixo para gerar e fazer o download do backup completo (.sql) do banco de dados PostgreSQL.
      </Typography>

      <div className={classes.buttonContainer}>
        <div className={classes.wrapper}>
          <Button
            variant="contained"
            color="primary"
            disabled={loading}
            startIcon={<CloudDownloadIcon />}
            onClick={handleDownloadBackup}
          >
            {loading ? "Gerando Backup..." : "Fazer Backup do Banco de Dados"}
          </Button>
          {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
        </div>
      </div>
    </Paper>
  );
};

export default DatabaseBackup;
